export default __webpack_public_path__ + "static/media/16.98864b63.jpg";